var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 1500,
    viewBox: "0 0 2000 1500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-25.4639 1125.55L32.3005 1007.31L-103.016 1011.09L-25.4639 1125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125.275 1259.66L18.7971 1220.74L-25.464 1125.55L-125.275 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 1107.87L96.281 993.489L32.3003 1007.31L122.194 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 1107.87L32.3006 1007.31L-25.4639 1125.55L122.194 1107.87Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7972 1220.74L122.194 1107.87L-25.4639 1125.55L18.7972 1220.74Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.1894 841.239L-103.016 1011.09L32.3005 1007.31L-17.1894 841.239Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.1895 1343.82L91.1191 1240.98L18.7971 1220.74L-17.1895 1343.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7969 1220.74L91.1189 1240.98L122.193 1107.87L18.7969 1220.74Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2811 993.489L-17.1895 841.239L32.3005 1007.31L96.2811 993.489Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125.275 1259.66L-17.1895 1343.82L18.7971 1220.74L-125.275 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1191 1240.98L242.847 1104.91L122.194 1107.87L91.1191 1240.98Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 1107.87L244.224 970.514L96.2812 993.489L122.194 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.708 1283.01L242.847 1104.91L91.1191 1240.98L279.708 1283.01Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.847 1104.91L244.224 970.514L122.194 1107.87L242.847 1104.91Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2811 1496.07L127.651 1366.24L-17.1895 1343.81L96.2811 1496.07Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.1895 1343.82L127.651 1366.24L91.1191 1240.98L-17.1895 1343.82Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.651 1366.24L279.708 1283.01L91.1191 1240.98L127.651 1366.24Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.847 1104.91L399.561 1011.09L244.224 970.514L242.847 1104.91Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.224 1473.09L225.114 1380.39L127.651 1366.24L244.224 1473.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.651 1366.24L225.114 1380.39L279.708 1283.01L127.651 1366.24Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-103.016 1513.67L32.3005 1509.88L-17.1894 1343.81L-103.016 1513.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.301 1259.66L380.352 1116.43L279.708 1283.01L377.301 1259.66Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.708 1283.01L380.352 1116.43L242.847 1104.91L279.708 1283.01Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3005 1509.88L96.2811 1496.07L-17.1895 1343.81L32.3005 1509.88Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.352 1116.43L399.561 1011.09L242.847 1104.91L380.352 1116.43Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.56 1011.09L345.393 839.245L244.224 970.514L399.56 1011.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.393 1341.82L377.301 1259.66L279.708 1283.01L345.393 1341.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.353 1116.43L477.113 1125.55L399.561 1011.09L380.353 1116.43Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.393 1341.82L279.708 1283.01L225.114 1380.39L345.393 1341.82Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.224 1473.09L345.393 1341.82L225.114 1380.39L244.224 1473.09Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2812 1496.07L244.224 1473.09L127.652 1366.24L96.2812 1496.07Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 1610.45L244.224 1473.09L96.2812 1496.07L122.194 1610.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.374 1220.74L477.113 1125.55L377.301 1259.66L521.374 1220.74Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.301 1259.66L477.113 1125.55L380.352 1116.43L377.301 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.561 1011.09L485.387 841.239L345.393 839.245L399.561 1011.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3003 1509.89L122.194 1610.45L96.281 1496.07L32.3003 1509.89Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.877 1007.31L485.387 841.239L399.561 1011.09L534.877 1007.31Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.113 1125.55L534.877 1007.31L399.561 1011.09L477.113 1125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 1343.82L521.374 1220.74L377.301 1259.66L485.387 1343.82Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 1343.81L377.301 1259.66L345.393 1341.82L485.387 1343.81Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 1343.82L345.393 1341.82L399.561 1513.67L485.387 1343.82Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.56 1513.67L345.393 1341.82L244.224 1473.09L399.56 1513.67Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 1610.45L242.847 1607.49L244.224 1473.09L122.194 1610.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.847 1607.49L399.561 1513.67L244.224 1473.09L242.847 1607.49Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.877 1007.31L598.858 993.489L485.387 841.239L534.877 1007.31Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.77 1107.87L534.877 1007.31L477.113 1125.55L624.77 1107.87Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.77 1107.87L477.113 1125.55L521.374 1220.74L624.77 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.228 1366.24L593.696 1240.98L485.387 1343.82L630.228 1366.24Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 1343.82L593.696 1240.98L521.374 1220.74L485.387 1343.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.561 1513.67L534.877 1509.88L485.387 1343.81L399.561 1513.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.858 1496.07L630.228 1366.24L485.387 1343.81L598.858 1496.07Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.877 1509.88L598.858 1496.07L485.387 1343.81L534.877 1509.88Z",
    fill: "#FBFBFB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.536 1125.55L532.301 1007.31L396.984 1011.09L474.536 1125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.725 1259.66L518.797 1220.74L474.536 1125.55L374.725 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 1107.87L596.281 993.489L532.3 1007.31L622.194 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 1107.87L532.301 1007.31L474.536 1125.55L622.194 1107.87Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.797 1220.74L622.194 1107.87L474.536 1125.55L518.797 1220.74Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.811 841.239L396.984 1011.09L532.301 1007.31L482.811 841.239Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.811 1343.82L591.119 1240.98L518.797 1220.74L482.811 1343.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.797 1220.74L591.119 1240.98L622.193 1107.87L518.797 1220.74Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.281 993.489L482.811 841.239L532.301 1007.31L596.281 993.489Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.725 1259.66L482.811 1343.82L518.797 1220.74L374.725 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.119 1240.98L742.847 1104.91L622.194 1107.87L591.119 1240.98Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 1107.87L744.224 970.514L596.281 993.489L622.194 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.708 1283.01L742.847 1104.91L591.119 1240.98L779.708 1283.01Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.847 1104.91L744.224 970.514L622.194 1107.87L742.847 1104.91Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.281 1496.07L627.651 1366.24L482.811 1343.81L596.281 1496.07Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.811 1343.82L627.651 1366.24L591.119 1240.98L482.811 1343.82Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.651 1366.24L779.708 1283.01L591.119 1240.98L627.651 1366.24Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.847 1104.91L899.561 1011.09L744.224 970.514L742.847 1104.91Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.224 1473.09L725.114 1380.39L627.651 1366.24L744.224 1473.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.651 1366.24L725.114 1380.39L779.708 1283.01L627.651 1366.24Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.984 1513.67L532.301 1509.88L482.811 1343.81L396.984 1513.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.301 1259.66L880.352 1116.43L779.708 1283.01L877.301 1259.66Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.708 1283.01L880.352 1116.43L742.847 1104.91L779.708 1283.01Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.301 1509.88L596.281 1496.07L482.811 1343.81L532.301 1509.88Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.352 1116.43L899.561 1011.09L742.847 1104.91L880.352 1116.43Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.56 1011.09L845.393 839.245L744.224 970.514L899.56 1011.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.393 1341.82L877.301 1259.66L779.708 1283.01L845.393 1341.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.353 1116.43L977.113 1125.55L899.561 1011.09L880.353 1116.43Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.393 1341.82L779.708 1283.01L725.114 1380.39L845.393 1341.82Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.224 1473.09L845.393 1341.82L725.114 1380.39L744.224 1473.09Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.281 1496.07L744.224 1473.09L627.652 1366.24L596.281 1496.07Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 1610.45L744.224 1473.09L596.281 1496.07L622.194 1610.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.37 1220.74L977.113 1125.55L877.301 1259.66L1021.37 1220.74Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.301 1259.66L977.113 1125.55L880.352 1116.43L877.301 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.561 1011.09L985.387 841.239L845.393 839.245L899.561 1011.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.3 1509.89L622.194 1610.45L596.281 1496.07L532.3 1509.89Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.88 1007.31L985.387 841.239L899.561 1011.09L1034.88 1007.31Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.113 1125.55L1034.88 1007.31L899.561 1011.09L977.113 1125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 1343.82L1021.37 1220.74L877.301 1259.66L985.387 1343.82Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 1343.81L877.301 1259.66L845.393 1341.82L985.387 1343.81Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 1343.82L845.393 1341.82L899.561 1513.67L985.387 1343.82Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.56 1513.67L845.393 1341.82L744.224 1473.09L899.56 1513.67Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 1610.45L742.847 1607.49L744.224 1473.09L622.194 1610.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.847 1607.49L899.561 1513.67L744.224 1473.09L742.847 1607.49Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.88 1007.31L1098.86 993.489L985.387 841.239L1034.88 1007.31Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.77 1107.87L1034.88 1007.31L977.113 1125.55L1124.77 1107.87Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.77 1107.87L977.113 1125.55L1021.37 1220.74L1124.77 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.23 1366.24L1093.7 1240.98L985.387 1343.82L1130.23 1366.24Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 1343.82L1093.7 1240.98L1021.37 1220.74L985.387 1343.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.561 1513.67L1034.88 1509.88L985.387 1343.81L899.561 1513.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.86 1496.07L1130.23 1366.24L985.387 1343.81L1098.86 1496.07Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.88 1509.88L1098.86 1496.07L985.387 1343.81L1034.88 1509.88Z",
    fill: "#FBFBFB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-25.4639 625.55L32.3005 507.308L-103.016 511.09L-25.4639 625.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125.275 759.663L18.7971 720.738L-25.464 625.55L-125.275 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 607.872L96.281 493.489L32.3003 507.308L122.194 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 607.872L32.3006 507.308L-25.4639 625.55L122.194 607.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7972 720.738L122.194 607.872L-25.4639 625.55L18.7972 720.738Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.1894 341.239L-103.016 511.09L32.3005 507.308L-17.1894 341.239Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.1895 843.815L91.1191 740.977L18.7971 720.738L-17.1895 843.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7969 720.738L91.1189 740.977L122.193 607.872L18.7969 720.738Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2811 493.489L-17.1895 341.239L32.3005 507.308L96.2811 493.489Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125.275 759.663L-17.1895 843.815L18.7971 720.738L-125.275 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1191 740.977L242.847 604.908L122.194 607.872L91.1191 740.977Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 607.872L244.224 470.514L96.2812 493.49L122.194 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.708 783.011L242.847 604.908L91.1191 740.977L279.708 783.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.847 604.908L244.224 470.514L122.194 607.872L242.847 604.908Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2811 996.066L127.651 866.243L-17.1895 843.815L96.2811 996.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.1895 843.815L127.651 866.243L91.1191 740.977L-17.1895 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.651 866.243L279.708 783.011L91.1191 740.977L127.651 866.243Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.847 604.908L399.561 511.09L244.224 470.514L242.847 604.908Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.224 973.091L225.114 880.389L127.651 866.243L244.224 973.091Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.651 866.243L225.114 880.389L279.708 783.01L127.651 866.243Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-103.016 1013.67L32.3005 1009.89L-17.1894 843.815L-103.016 1013.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.301 759.663L380.352 616.434L279.708 783.011L377.301 759.663Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.708 783.011L380.352 616.434L242.847 604.908L279.708 783.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3005 1009.89L96.2811 996.066L-17.1895 843.815L32.3005 1009.89Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.352 616.434L399.561 511.09L242.847 604.908L380.352 616.434Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.56 511.09L345.393 339.245L244.224 470.514L399.56 511.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.393 841.822L377.301 759.663L279.708 783.011L345.393 841.822Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.353 616.434L477.113 625.55L399.561 511.09L380.353 616.434Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.393 841.822L279.708 783.01L225.114 880.389L345.393 841.822Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.224 973.091L345.393 841.822L225.114 880.389L244.224 973.091Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2812 996.066L244.224 973.091L127.652 866.243L96.2812 996.066Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 1110.45L244.224 973.091L96.2812 996.066L122.194 1110.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.374 720.738L477.113 625.55L377.301 759.663L521.374 720.738Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.301 759.663L477.113 625.55L380.352 616.434L377.301 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.561 511.09L485.387 341.239L345.393 339.245L399.561 511.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3003 1009.89L122.194 1110.45L96.281 996.066L32.3003 1009.89Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.877 507.308L485.387 341.239L399.561 511.09L534.877 507.308Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.113 625.55L534.877 507.308L399.561 511.09L477.113 625.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 843.815L521.374 720.738L377.301 759.663L485.387 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 843.815L377.301 759.663L345.393 841.822L485.387 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 843.815L345.393 841.822L399.561 1013.67L485.387 843.815Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.56 1013.67L345.393 841.822L244.224 973.091L399.56 1013.67Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 1110.45L242.847 1107.49L244.224 973.091L122.194 1110.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.847 1107.49L399.561 1013.67L244.224 973.091L242.847 1107.49Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.877 507.308L598.858 493.489L485.387 341.239L534.877 507.308Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.77 607.872L534.877 507.308L477.113 625.55L624.77 607.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.77 607.872L477.113 625.55L521.374 720.738L624.77 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.228 866.243L593.696 740.977L485.387 843.815L630.228 866.243Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 843.815L593.696 740.977L521.374 720.738L485.387 843.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.561 1013.67L534.877 1009.89L485.387 843.815L399.561 1013.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.858 996.066L630.228 866.243L485.387 843.815L598.858 996.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.877 1009.89L598.858 996.066L485.387 843.815L534.877 1009.89Z",
    fill: "#FBFBFB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.536 625.55L532.301 507.308L396.984 511.09L474.536 625.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.725 759.663L518.797 720.738L474.536 625.55L374.725 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 607.872L596.281 493.489L532.3 507.308L622.194 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 607.872L532.301 507.308L474.536 625.55L622.194 607.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.797 720.738L622.194 607.872L474.536 625.55L518.797 720.738Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.811 341.239L396.984 511.09L532.301 507.308L482.811 341.239Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.811 843.815L591.119 740.977L518.797 720.738L482.811 843.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.797 720.738L591.119 740.977L622.193 607.872L518.797 720.738Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.281 493.489L482.811 341.239L532.301 507.308L596.281 493.489Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.725 759.663L482.811 843.815L518.797 720.738L374.725 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.119 740.977L742.847 604.908L622.194 607.872L591.119 740.977Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 607.872L744.224 470.514L596.281 493.49L622.194 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.708 783.011L742.847 604.908L591.119 740.977L779.708 783.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.847 604.908L744.224 470.514L622.194 607.872L742.847 604.908Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.281 996.066L627.651 866.243L482.811 843.815L596.281 996.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.811 843.815L627.651 866.243L591.119 740.977L482.811 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.651 866.243L779.708 783.011L591.119 740.977L627.651 866.243Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.847 604.908L899.561 511.09L744.224 470.514L742.847 604.908Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.224 973.091L725.114 880.389L627.651 866.243L744.224 973.091Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.651 866.243L725.114 880.389L779.708 783.01L627.651 866.243Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.984 1013.67L532.301 1009.89L482.811 843.815L396.984 1013.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.301 759.663L880.352 616.434L779.708 783.011L877.301 759.663Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.708 783.011L880.352 616.434L742.847 604.908L779.708 783.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.301 1009.89L596.281 996.066L482.811 843.815L532.301 1009.89Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.352 616.434L899.561 511.09L742.847 604.908L880.352 616.434Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.56 511.09L845.393 339.245L744.224 470.514L899.56 511.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.393 841.822L877.301 759.663L779.708 783.011L845.393 841.822Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.353 616.434L977.113 625.55L899.561 511.09L880.353 616.434Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.393 841.822L779.708 783.01L725.114 880.389L845.393 841.822Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.224 973.091L845.393 841.822L725.114 880.389L744.224 973.091Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.281 996.066L744.224 973.091L627.652 866.243L596.281 996.066Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 1110.45L744.224 973.091L596.281 996.066L622.194 1110.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.37 720.738L977.113 625.55L877.301 759.663L1021.37 720.738Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.301 759.663L977.113 625.55L880.352 616.434L877.301 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.561 511.09L985.387 341.239L845.393 339.245L899.561 511.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.3 1009.89L622.194 1110.45L596.281 996.066L532.3 1009.89Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.88 507.308L985.387 341.239L899.561 511.09L1034.88 507.308Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.113 625.55L1034.88 507.308L899.561 511.09L977.113 625.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 843.815L1021.37 720.738L877.301 759.663L985.387 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 843.815L877.301 759.663L845.393 841.822L985.387 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 843.815L845.393 841.822L899.561 1013.67L985.387 843.815Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.56 1013.67L845.393 841.822L744.224 973.091L899.56 1013.67Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 1110.45L742.847 1107.49L744.224 973.091L622.194 1110.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.847 1107.49L899.561 1013.67L744.224 973.091L742.847 1107.49Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.88 507.308L1098.86 493.489L985.387 341.239L1034.88 507.308Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.77 607.872L1034.88 507.308L977.113 625.55L1124.77 607.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.77 607.872L977.113 625.55L1021.37 720.738L1124.77 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.23 866.243L1093.7 740.977L985.387 843.815L1130.23 866.243Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 843.815L1093.7 740.977L1021.37 720.738L985.387 843.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.561 1013.67L1034.88 1009.89L985.387 843.815L899.561 1013.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.86 996.066L1130.23 866.243L985.387 843.815L1098.86 996.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.88 1009.89L1098.86 996.066L985.387 843.815L1034.88 1009.89Z",
    fill: "#FBFBFB"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M974.536 1125.55L1032.3 1007.31L896.984 1011.09L974.536 1125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.725 1259.66L1018.8 1220.74L974.536 1125.55L874.725 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 1107.87L1096.28 993.489L1032.3 1007.31L1122.19 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 1107.87L1032.3 1007.31L974.536 1125.55L1122.19 1107.87Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.8 1220.74L1122.19 1107.87L974.536 1125.55L1018.8 1220.74Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.811 841.239L896.984 1011.09L1032.3 1007.31L982.811 841.239Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.811 1343.82L1091.12 1240.98L1018.8 1220.74L982.811 1343.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.8 1220.74L1091.12 1240.98L1122.19 1107.87L1018.8 1220.74Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.28 993.489L982.811 841.239L1032.3 1007.31L1096.28 993.489Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.725 1259.66L982.811 1343.82L1018.8 1220.74L874.725 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.12 1240.98L1242.85 1104.91L1122.19 1107.87L1091.12 1240.98Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 1107.87L1244.22 970.514L1096.28 993.489L1122.19 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.71 1283.01L1242.85 1104.91L1091.12 1240.98L1279.71 1283.01Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.85 1104.91L1244.22 970.514L1122.19 1107.87L1242.85 1104.91Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.28 1496.07L1127.65 1366.24L982.811 1343.81L1096.28 1496.07Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.811 1343.82L1127.65 1366.24L1091.12 1240.98L982.811 1343.82Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.65 1366.24L1279.71 1283.01L1091.12 1240.98L1127.65 1366.24Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.85 1104.91L1399.56 1011.09L1244.22 970.514L1242.85 1104.91Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.22 1473.09L1225.11 1380.39L1127.65 1366.24L1244.22 1473.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.65 1366.24L1225.11 1380.39L1279.71 1283.01L1127.65 1366.24Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.984 1513.67L1032.3 1509.88L982.811 1343.81L896.984 1513.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.3 1259.66L1380.35 1116.43L1279.71 1283.01L1377.3 1259.66Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.71 1283.01L1380.35 1116.43L1242.85 1104.91L1279.71 1283.01Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 1509.88L1096.28 1496.07L982.811 1343.81L1032.3 1509.88Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.35 1116.43L1399.56 1011.09L1242.85 1104.91L1380.35 1116.43Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 1011.09L1345.39 839.245L1244.22 970.514L1399.56 1011.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.39 1341.82L1377.3 1259.66L1279.71 1283.01L1345.39 1341.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.35 1116.43L1477.11 1125.55L1399.56 1011.09L1380.35 1116.43Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.39 1341.82L1279.71 1283.01L1225.11 1380.39L1345.39 1341.82Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.22 1473.09L1345.39 1341.82L1225.11 1380.39L1244.22 1473.09Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.28 1496.07L1244.22 1473.09L1127.65 1366.24L1096.28 1496.07Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 1610.45L1244.22 1473.09L1096.28 1496.07L1122.19 1610.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.37 1220.74L1477.11 1125.55L1377.3 1259.66L1521.37 1220.74Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.3 1259.66L1477.11 1125.55L1380.35 1116.43L1377.3 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 1011.09L1485.39 841.239L1345.39 839.245L1399.56 1011.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 1509.89L1122.19 1610.45L1096.28 1496.07L1032.3 1509.89Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.88 1007.31L1485.39 841.239L1399.56 1011.09L1534.88 1007.31Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477.11 1125.55L1534.88 1007.31L1399.56 1011.09L1477.11 1125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 1343.82L1521.37 1220.74L1377.3 1259.66L1485.39 1343.82Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 1343.81L1377.3 1259.66L1345.39 1341.82L1485.39 1343.81Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 1343.82L1345.39 1341.82L1399.56 1513.67L1485.39 1343.82Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 1513.67L1345.39 1341.82L1244.22 1473.09L1399.56 1513.67Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 1610.45L1242.85 1607.49L1244.22 1473.09L1122.19 1610.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.85 1607.49L1399.56 1513.67L1244.22 1473.09L1242.85 1607.49Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.88 1007.31L1598.86 993.489L1485.39 841.239L1534.88 1007.31Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.77 1107.87L1534.88 1007.31L1477.11 1125.55L1624.77 1107.87Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.77 1107.87L1477.11 1125.55L1521.37 1220.74L1624.77 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630.23 1366.24L1593.7 1240.98L1485.39 1343.82L1630.23 1366.24Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 1343.82L1593.7 1240.98L1521.37 1220.74L1485.39 1343.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 1513.67L1534.88 1509.88L1485.39 1343.81L1399.56 1513.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1598.86 1496.07L1630.23 1366.24L1485.39 1343.81L1598.86 1496.07Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.88 1509.88L1598.86 1496.07L1485.39 1343.81L1534.88 1509.88Z",
    fill: "#FBFBFB"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1474.54 1125.55L1532.3 1007.31L1396.98 1011.09L1474.54 1125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.73 1259.66L1518.8 1220.74L1474.54 1125.55L1374.73 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 1107.87L1596.28 993.489L1532.3 1007.31L1622.19 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 1107.87L1532.3 1007.31L1474.54 1125.55L1622.19 1107.87Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.8 1220.74L1622.19 1107.87L1474.54 1125.55L1518.8 1220.74Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.81 841.239L1396.98 1011.09L1532.3 1007.31L1482.81 841.239Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.81 1343.82L1591.12 1240.98L1518.8 1220.74L1482.81 1343.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.8 1220.74L1591.12 1240.98L1622.19 1107.87L1518.8 1220.74Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.28 993.489L1482.81 841.239L1532.3 1007.31L1596.28 993.489Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.73 1259.66L1482.81 1343.82L1518.8 1220.74L1374.73 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.12 1240.98L1742.85 1104.91L1622.19 1107.87L1591.12 1240.98Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 1107.87L1744.22 970.514L1596.28 993.489L1622.19 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.71 1283.01L1742.85 1104.91L1591.12 1240.98L1779.71 1283.01Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.85 1104.91L1744.22 970.514L1622.19 1107.87L1742.85 1104.91Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.28 1496.07L1627.65 1366.24L1482.81 1343.81L1596.28 1496.07Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.81 1343.82L1627.65 1366.24L1591.12 1240.98L1482.81 1343.82Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.65 1366.24L1779.71 1283.01L1591.12 1240.98L1627.65 1366.24Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.85 1104.91L1899.56 1011.09L1744.22 970.514L1742.85 1104.91Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.22 1473.09L1725.11 1380.39L1627.65 1366.24L1744.22 1473.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.65 1366.24L1725.11 1380.39L1779.71 1283.01L1627.65 1366.24Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.98 1513.67L1532.3 1509.88L1482.81 1343.81L1396.98 1513.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877.3 1259.66L1880.35 1116.43L1779.71 1283.01L1877.3 1259.66Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.71 1283.01L1880.35 1116.43L1742.85 1104.91L1779.71 1283.01Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.3 1509.88L1596.28 1496.07L1482.81 1343.81L1532.3 1509.88Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.35 1116.43L1899.56 1011.09L1742.85 1104.91L1880.35 1116.43Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 1011.09L1845.39 839.245L1744.22 970.514L1899.56 1011.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.39 1341.82L1877.3 1259.66L1779.71 1283.01L1845.39 1341.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.35 1116.43L1977.11 1125.55L1899.56 1011.09L1880.35 1116.43Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.39 1341.82L1779.71 1283.01L1725.11 1380.39L1845.39 1341.82Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.22 1473.09L1845.39 1341.82L1725.11 1380.39L1744.22 1473.09Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.28 1496.07L1744.22 1473.09L1627.65 1366.24L1596.28 1496.07Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 1610.45L1744.22 1473.09L1596.28 1496.07L1622.19 1610.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021.37 1220.74L1977.11 1125.55L1877.3 1259.66L2021.37 1220.74Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877.3 1259.66L1977.11 1125.55L1880.35 1116.43L1877.3 1259.66Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 1011.09L1985.39 841.239L1845.39 839.245L1899.56 1011.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.3 1509.89L1622.19 1610.45L1596.28 1496.07L1532.3 1509.89Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2034.88 1007.31L1985.39 841.239L1899.56 1011.09L2034.88 1007.31Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1977.11 1125.55L2034.88 1007.31L1899.56 1011.09L1977.11 1125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 1343.82L2021.37 1220.74L1877.3 1259.66L1985.39 1343.82Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 1343.81L1877.3 1259.66L1845.39 1341.82L1985.39 1343.81Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 1343.82L1845.39 1341.82L1899.56 1513.67L1985.39 1343.82Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 1513.67L1845.39 1341.82L1744.22 1473.09L1899.56 1513.67Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 1610.45L1742.85 1607.49L1744.22 1473.09L1622.19 1610.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.85 1607.49L1899.56 1513.67L1744.22 1473.09L1742.85 1607.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2034.88 1007.31L2098.86 993.489L1985.39 841.239L2034.88 1007.31Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124.77 1107.87L2034.88 1007.31L1977.11 1125.55L2124.77 1107.87Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124.77 1107.87L1977.11 1125.55L2021.37 1220.74L2124.77 1107.87Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130.23 1366.24L2093.7 1240.98L1985.39 1343.82L2130.23 1366.24Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 1343.82L2093.7 1240.98L2021.37 1220.74L1985.39 1343.82Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 1513.67L2034.88 1509.88L1985.39 1343.81L1899.56 1513.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2098.86 1496.07L2130.23 1366.24L1985.39 1343.81L2098.86 1496.07Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2034.88 1509.88L2098.86 1496.07L1985.39 1343.81L2034.88 1509.88Z",
    fill: "#FBFBFB"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M974.536 625.55L1032.3 507.308L896.984 511.09L974.536 625.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.725 759.663L1018.8 720.738L974.536 625.55L874.725 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 607.872L1096.28 493.489L1032.3 507.308L1122.19 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 607.872L1032.3 507.308L974.536 625.55L1122.19 607.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.8 720.738L1122.19 607.872L974.536 625.55L1018.8 720.738Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.811 341.239L896.984 511.09L1032.3 507.308L982.811 341.239Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.811 843.815L1091.12 740.977L1018.8 720.738L982.811 843.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.8 720.738L1091.12 740.977L1122.19 607.872L1018.8 720.738Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.28 493.489L982.811 341.239L1032.3 507.308L1096.28 493.489Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.725 759.663L982.811 843.815L1018.8 720.738L874.725 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.12 740.977L1242.85 604.908L1122.19 607.872L1091.12 740.977Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 607.872L1244.22 470.514L1096.28 493.49L1122.19 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.71 783.011L1242.85 604.908L1091.12 740.977L1279.71 783.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.85 604.908L1244.22 470.514L1122.19 607.872L1242.85 604.908Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.28 996.066L1127.65 866.243L982.811 843.815L1096.28 996.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.811 843.815L1127.65 866.243L1091.12 740.977L982.811 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.65 866.243L1279.71 783.011L1091.12 740.977L1127.65 866.243Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.85 604.908L1399.56 511.09L1244.22 470.514L1242.85 604.908Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.22 973.091L1225.11 880.389L1127.65 866.243L1244.22 973.091Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.65 866.243L1225.11 880.389L1279.71 783.01L1127.65 866.243Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.984 1013.67L1032.3 1009.89L982.811 843.815L896.984 1013.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.3 759.663L1380.35 616.434L1279.71 783.011L1377.3 759.663Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.71 783.011L1380.35 616.434L1242.85 604.908L1279.71 783.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 1009.89L1096.28 996.066L982.811 843.815L1032.3 1009.89Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.35 616.434L1399.56 511.09L1242.85 604.908L1380.35 616.434Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 511.09L1345.39 339.245L1244.22 470.514L1399.56 511.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.39 841.822L1377.3 759.663L1279.71 783.011L1345.39 841.822Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.35 616.434L1477.11 625.55L1399.56 511.09L1380.35 616.434Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.39 841.822L1279.71 783.01L1225.11 880.389L1345.39 841.822Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.22 973.091L1345.39 841.822L1225.11 880.389L1244.22 973.091Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.28 996.066L1244.22 973.091L1127.65 866.243L1096.28 996.066Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 1110.45L1244.22 973.091L1096.28 996.066L1122.19 1110.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.37 720.738L1477.11 625.55L1377.3 759.663L1521.37 720.738Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.3 759.663L1477.11 625.55L1380.35 616.434L1377.3 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 511.09L1485.39 341.239L1345.39 339.245L1399.56 511.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 1009.89L1122.19 1110.45L1096.28 996.066L1032.3 1009.89Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.88 507.308L1485.39 341.239L1399.56 511.09L1534.88 507.308Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477.11 625.55L1534.88 507.308L1399.56 511.09L1477.11 625.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 843.815L1521.37 720.738L1377.3 759.663L1485.39 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 843.815L1377.3 759.663L1345.39 841.822L1485.39 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 843.815L1345.39 841.822L1399.56 1013.67L1485.39 843.815Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 1013.67L1345.39 841.822L1244.22 973.091L1399.56 1013.67Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 1110.45L1242.85 1107.49L1244.22 973.091L1122.19 1110.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.85 1107.49L1399.56 1013.67L1244.22 973.091L1242.85 1107.49Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.88 507.308L1598.86 493.489L1485.39 341.239L1534.88 507.308Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.77 607.872L1534.88 507.308L1477.11 625.55L1624.77 607.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.77 607.872L1477.11 625.55L1521.37 720.738L1624.77 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630.23 866.243L1593.7 740.977L1485.39 843.815L1630.23 866.243Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 843.815L1593.7 740.977L1521.37 720.738L1485.39 843.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 1013.67L1534.88 1009.89L1485.39 843.815L1399.56 1013.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1598.86 996.066L1630.23 866.243L1485.39 843.815L1598.86 996.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.88 1009.89L1598.86 996.066L1485.39 843.815L1534.88 1009.89Z",
    fill: "#FBFBFB"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1474.54 625.55L1532.3 507.308L1396.98 511.09L1474.54 625.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.73 759.663L1518.8 720.738L1474.54 625.55L1374.73 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 607.872L1596.28 493.489L1532.3 507.308L1622.19 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 607.872L1532.3 507.308L1474.54 625.55L1622.19 607.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.8 720.738L1622.19 607.872L1474.54 625.55L1518.8 720.738Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.81 341.239L1396.98 511.09L1532.3 507.308L1482.81 341.239Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.81 843.815L1591.12 740.977L1518.8 720.738L1482.81 843.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.8 720.738L1591.12 740.977L1622.19 607.872L1518.8 720.738Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.28 493.489L1482.81 341.239L1532.3 507.308L1596.28 493.489Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.73 759.663L1482.81 843.815L1518.8 720.738L1374.73 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.12 740.977L1742.85 604.908L1622.19 607.872L1591.12 740.977Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 607.872L1744.22 470.514L1596.28 493.49L1622.19 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.71 783.011L1742.85 604.908L1591.12 740.977L1779.71 783.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.85 604.908L1744.22 470.514L1622.19 607.872L1742.85 604.908Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.28 996.066L1627.65 866.243L1482.81 843.815L1596.28 996.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.81 843.815L1627.65 866.243L1591.12 740.977L1482.81 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.65 866.243L1779.71 783.011L1591.12 740.977L1627.65 866.243Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.85 604.908L1899.56 511.09L1744.22 470.514L1742.85 604.908Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.22 973.091L1725.11 880.389L1627.65 866.243L1744.22 973.091Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.65 866.243L1725.11 880.389L1779.71 783.01L1627.65 866.243Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.98 1013.67L1532.3 1009.89L1482.81 843.815L1396.98 1013.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877.3 759.663L1880.35 616.434L1779.71 783.011L1877.3 759.663Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.71 783.011L1880.35 616.434L1742.85 604.908L1779.71 783.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.3 1009.89L1596.28 996.066L1482.81 843.815L1532.3 1009.89Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.35 616.434L1899.56 511.09L1742.85 604.908L1880.35 616.434Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 511.09L1845.39 339.245L1744.22 470.514L1899.56 511.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.39 841.822L1877.3 759.663L1779.71 783.011L1845.39 841.822Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.35 616.434L1977.11 625.55L1899.56 511.09L1880.35 616.434Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.39 841.822L1779.71 783.01L1725.11 880.389L1845.39 841.822Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.22 973.091L1845.39 841.822L1725.11 880.389L1744.22 973.091Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.28 996.066L1744.22 973.091L1627.65 866.243L1596.28 996.066Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 1110.45L1744.22 973.091L1596.28 996.066L1622.19 1110.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021.37 720.738L1977.11 625.55L1877.3 759.663L2021.37 720.738Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877.3 759.663L1977.11 625.55L1880.35 616.434L1877.3 759.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 511.09L1985.39 341.239L1845.39 339.245L1899.56 511.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.3 1009.89L1622.19 1110.45L1596.28 996.066L1532.3 1009.89Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2034.88 507.308L1985.39 341.239L1899.56 511.09L2034.88 507.308Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1977.11 625.55L2034.88 507.308L1899.56 511.09L1977.11 625.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 843.815L2021.37 720.738L1877.3 759.663L1985.39 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 843.815L1877.3 759.663L1845.39 841.822L1985.39 843.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 843.815L1845.39 841.822L1899.56 1013.67L1985.39 843.815Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 1013.67L1845.39 841.822L1744.22 973.091L1899.56 1013.67Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 1110.45L1742.85 1107.49L1744.22 973.091L1622.19 1110.45Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.85 1107.49L1899.56 1013.67L1744.22 973.091L1742.85 1107.49Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2034.88 507.308L2098.86 493.489L1985.39 341.239L2034.88 507.308Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124.77 607.872L2034.88 507.308L1977.11 625.55L2124.77 607.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124.77 607.872L1977.11 625.55L2021.37 720.738L2124.77 607.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130.23 866.243L2093.7 740.977L1985.39 843.815L2130.23 866.243Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 843.815L2093.7 740.977L2021.37 720.738L1985.39 843.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 1013.67L2034.88 1009.89L1985.39 843.815L1899.56 1013.67Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2098.86 996.066L2130.23 866.243L1985.39 843.815L2098.86 996.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2034.88 1009.89L2098.86 996.066L1985.39 843.815L2034.88 1009.89Z",
    fill: "#FBFBFB"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-25.4639 125.55L32.3005 7.30811L-103.016 11.09L-25.4639 125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125.275 259.663L18.7971 220.738L-25.464 125.55L-125.275 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 107.872L96.281 -6.51074L32.3003 7.30784L122.194 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 107.872L32.3006 7.30811L-25.4639 125.55L122.194 107.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7972 220.738L122.194 107.872L-25.4639 125.55L18.7972 220.738Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.1894 -158.761L-103.016 11.0898L32.3005 7.30783L-17.1894 -158.761Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.1895 343.815L91.1191 240.977L18.7971 220.738L-17.1895 343.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7969 220.738L91.1189 240.977L122.193 107.872L18.7969 220.738Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2811 -6.51074L-17.1895 -158.761L32.3005 7.30783L96.2811 -6.51074Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125.275 259.663L-17.1895 343.815L18.7971 220.738L-125.275 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1191 240.977L242.847 104.908L122.194 107.872L91.1191 240.977Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 107.872L244.224 -29.4856L96.2812 -6.51048L122.194 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.708 283.011L242.847 104.908L91.1191 240.977L279.708 283.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.847 104.908L244.224 -29.4856L122.194 107.872L242.847 104.908Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2811 496.066L127.651 366.243L-17.1895 343.815L96.2811 496.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.1895 343.815L127.651 366.243L91.1191 240.977L-17.1895 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.651 366.243L279.708 283.011L91.1191 240.977L127.651 366.243Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.847 104.908L399.561 11.0901L244.224 -29.4856L242.847 104.908Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.224 473.091L225.114 380.389L127.651 366.243L244.224 473.091Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.651 366.243L225.114 380.389L279.708 283.01L127.651 366.243Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-103.016 513.667L32.3005 509.885L-17.1894 343.815L-103.016 513.667Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.301 259.663L380.352 116.434L279.708 283.011L377.301 259.663Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.708 283.011L380.352 116.434L242.847 104.908L279.708 283.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3005 509.885L96.2811 496.066L-17.1895 343.815L32.3005 509.885Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.352 116.434L399.561 11.0898L242.847 104.908L380.352 116.434Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.56 11.09L345.393 -160.755L244.224 -29.4858L399.56 11.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.393 341.822L377.301 259.663L279.708 283.011L345.393 341.822Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.353 116.434L477.113 125.55L399.561 11.0898L380.353 116.434Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.393 341.822L279.708 283.01L225.114 380.389L345.393 341.822Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.224 473.091L345.393 341.822L225.114 380.389L244.224 473.091Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2812 496.066L244.224 473.091L127.652 366.243L96.2812 496.066Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 610.448L244.224 473.091L96.2812 496.066L122.194 610.448Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.374 220.738L477.113 125.55L377.301 259.663L521.374 220.738Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.301 259.663L477.113 125.55L380.352 116.434L377.301 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.561 11.09L485.387 -158.761L345.393 -160.755L399.561 11.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3003 509.885L122.194 610.449L96.281 496.066L32.3003 509.885Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.877 7.30783L485.387 -158.761L399.561 11.0898L534.877 7.30783Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.113 125.55L534.877 7.30811L399.561 11.09L477.113 125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 343.815L521.374 220.738L377.301 259.663L485.387 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 343.815L377.301 259.663L345.393 341.822L485.387 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 343.815L345.393 341.822L399.561 513.666L485.387 343.815Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.56 513.666L345.393 341.822L244.224 473.091L399.56 513.666Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.194 610.448L242.847 607.485L244.224 473.091L122.194 610.448Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.847 607.485L399.561 513.667L244.224 473.091L242.847 607.485Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.877 7.30783L598.858 -6.51074L485.387 -158.761L534.877 7.30783Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.77 107.872L534.877 7.30811L477.113 125.55L624.77 107.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.77 107.872L477.113 125.55L521.374 220.738L624.77 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.228 366.243L593.696 240.977L485.387 343.815L630.228 366.243Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.387 343.815L593.696 240.977L521.374 220.738L485.387 343.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.561 513.667L534.877 509.885L485.387 343.815L399.561 513.667Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.858 496.066L630.228 366.243L485.387 343.815L598.858 496.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.877 509.885L598.858 496.066L485.387 343.815L534.877 509.885Z",
    fill: "#FBFBFB"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.536 125.55L532.301 7.30811L396.984 11.09L474.536 125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.725 259.663L518.797 220.738L474.536 125.55L374.725 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 107.872L596.281 -6.51074L532.3 7.30784L622.194 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 107.872L532.301 7.30811L474.536 125.55L622.194 107.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.797 220.738L622.194 107.872L474.536 125.55L518.797 220.738Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.811 -158.761L396.984 11.0898L532.301 7.30783L482.811 -158.761Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.811 343.815L591.119 240.977L518.797 220.738L482.811 343.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.797 220.738L591.119 240.977L622.193 107.872L518.797 220.738Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.281 -6.51074L482.811 -158.761L532.301 7.30783L596.281 -6.51074Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.725 259.663L482.811 343.815L518.797 220.738L374.725 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.119 240.977L742.847 104.908L622.194 107.872L591.119 240.977Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 107.872L744.224 -29.4856L596.281 -6.51048L622.194 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.708 283.011L742.847 104.908L591.119 240.977L779.708 283.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.847 104.908L744.224 -29.4856L622.194 107.872L742.847 104.908Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.281 496.066L627.651 366.243L482.811 343.815L596.281 496.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.811 343.815L627.651 366.243L591.119 240.977L482.811 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.651 366.243L779.708 283.011L591.119 240.977L627.651 366.243Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.847 104.908L899.561 11.0901L744.224 -29.4856L742.847 104.908Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.224 473.091L725.114 380.389L627.651 366.243L744.224 473.091Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.651 366.243L725.114 380.389L779.708 283.01L627.651 366.243Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.984 513.667L532.301 509.885L482.811 343.815L396.984 513.667Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.301 259.663L880.352 116.434L779.708 283.011L877.301 259.663Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.708 283.011L880.352 116.434L742.847 104.908L779.708 283.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.301 509.885L596.281 496.066L482.811 343.815L532.301 509.885Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.352 116.434L899.561 11.0898L742.847 104.908L880.352 116.434Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.56 11.09L845.393 -160.755L744.224 -29.4858L899.56 11.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.393 341.822L877.301 259.663L779.708 283.011L845.393 341.822Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.353 116.434L977.113 125.55L899.561 11.0898L880.353 116.434Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.393 341.822L779.708 283.01L725.114 380.389L845.393 341.822Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.224 473.091L845.393 341.822L725.114 380.389L744.224 473.091Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.281 496.066L744.224 473.091L627.652 366.243L596.281 496.066Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 610.448L744.224 473.091L596.281 496.066L622.194 610.448Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.37 220.738L977.113 125.55L877.301 259.663L1021.37 220.738Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.301 259.663L977.113 125.55L880.352 116.434L877.301 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.561 11.09L985.387 -158.761L845.393 -160.755L899.561 11.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.3 509.885L622.194 610.449L596.281 496.066L532.3 509.885Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.88 7.30783L985.387 -158.761L899.561 11.0898L1034.88 7.30783Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.113 125.55L1034.88 7.30811L899.561 11.09L977.113 125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 343.815L1021.37 220.738L877.301 259.663L985.387 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 343.815L877.301 259.663L845.393 341.822L985.387 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 343.815L845.393 341.822L899.561 513.666L985.387 343.815Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.56 513.666L845.393 341.822L744.224 473.091L899.56 513.666Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194 610.448L742.847 607.485L744.224 473.091L622.194 610.448Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.847 607.485L899.561 513.667L744.224 473.091L742.847 607.485Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.88 7.30783L1098.86 -6.51074L985.387 -158.761L1034.88 7.30783Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.77 107.872L1034.88 7.30811L977.113 125.55L1124.77 107.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.77 107.872L977.113 125.55L1021.37 220.738L1124.77 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.23 366.243L1093.7 240.977L985.387 343.815L1130.23 366.243Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.387 343.815L1093.7 240.977L1021.37 220.738L985.387 343.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.561 513.667L1034.88 509.885L985.387 343.815L899.561 513.667Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.86 496.066L1130.23 366.243L985.387 343.815L1098.86 496.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.88 509.885L1098.86 496.066L985.387 343.815L1034.88 509.885Z",
    fill: "#FBFBFB"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M974.536 125.55L1032.3 7.30811L896.984 11.09L974.536 125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.725 259.663L1018.8 220.738L974.536 125.55L874.725 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 107.872L1096.28 -6.51074L1032.3 7.30784L1122.19 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 107.872L1032.3 7.30811L974.536 125.55L1122.19 107.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.8 220.738L1122.19 107.872L974.536 125.55L1018.8 220.738Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.811 -158.761L896.984 11.0898L1032.3 7.30783L982.811 -158.761Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.811 343.815L1091.12 240.977L1018.8 220.738L982.811 343.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.8 220.738L1091.12 240.977L1122.19 107.872L1018.8 220.738Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.28 -6.51074L982.811 -158.761L1032.3 7.30783L1096.28 -6.51074Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.725 259.663L982.811 343.815L1018.8 220.738L874.725 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.12 240.977L1242.85 104.908L1122.19 107.872L1091.12 240.977Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 107.872L1244.22 -29.4856L1096.28 -6.51048L1122.19 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.71 283.011L1242.85 104.908L1091.12 240.977L1279.71 283.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.85 104.908L1244.22 -29.4856L1122.19 107.872L1242.85 104.908Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.28 496.066L1127.65 366.243L982.811 343.815L1096.28 496.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.811 343.815L1127.65 366.243L1091.12 240.977L982.811 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.65 366.243L1279.71 283.011L1091.12 240.977L1127.65 366.243Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.85 104.908L1399.56 11.0901L1244.22 -29.4856L1242.85 104.908Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.22 473.091L1225.11 380.389L1127.65 366.243L1244.22 473.091Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.65 366.243L1225.11 380.389L1279.71 283.01L1127.65 366.243Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.984 513.667L1032.3 509.885L982.811 343.815L896.984 513.667Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.3 259.663L1380.35 116.434L1279.71 283.011L1377.3 259.663Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.71 283.011L1380.35 116.434L1242.85 104.908L1279.71 283.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 509.885L1096.28 496.066L982.811 343.815L1032.3 509.885Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.35 116.434L1399.56 11.0898L1242.85 104.908L1380.35 116.434Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 11.09L1345.39 -160.755L1244.22 -29.4858L1399.56 11.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.39 341.822L1377.3 259.663L1279.71 283.011L1345.39 341.822Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.35 116.434L1477.11 125.55L1399.56 11.0898L1380.35 116.434Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.39 341.822L1279.71 283.01L1225.11 380.389L1345.39 341.822Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.22 473.091L1345.39 341.822L1225.11 380.389L1244.22 473.091Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.28 496.066L1244.22 473.091L1127.65 366.243L1096.28 496.066Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 610.448L1244.22 473.091L1096.28 496.066L1122.19 610.448Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.37 220.738L1477.11 125.55L1377.3 259.663L1521.37 220.738Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.3 259.663L1477.11 125.55L1380.35 116.434L1377.3 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 11.09L1485.39 -158.761L1345.39 -160.755L1399.56 11.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.3 509.885L1122.19 610.449L1096.28 496.066L1032.3 509.885Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.88 7.30783L1485.39 -158.761L1399.56 11.0898L1534.88 7.30783Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477.11 125.55L1534.88 7.30811L1399.56 11.09L1477.11 125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 343.815L1521.37 220.738L1377.3 259.663L1485.39 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 343.815L1377.3 259.663L1345.39 341.822L1485.39 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 343.815L1345.39 341.822L1399.56 513.666L1485.39 343.815Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 513.666L1345.39 341.822L1244.22 473.091L1399.56 513.666Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.19 610.448L1242.85 607.485L1244.22 473.091L1122.19 610.448Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.85 607.485L1399.56 513.667L1244.22 473.091L1242.85 607.485Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.88 7.30783L1598.86 -6.51074L1485.39 -158.761L1534.88 7.30783Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.77 107.872L1534.88 7.30811L1477.11 125.55L1624.77 107.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.77 107.872L1477.11 125.55L1521.37 220.738L1624.77 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630.23 366.243L1593.7 240.977L1485.39 343.815L1630.23 366.243Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 343.815L1593.7 240.977L1521.37 220.738L1485.39 343.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.56 513.667L1534.88 509.885L1485.39 343.815L1399.56 513.667Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1598.86 496.066L1630.23 366.243L1485.39 343.815L1598.86 496.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.88 509.885L1598.86 496.066L1485.39 343.815L1534.88 509.885Z",
    fill: "#FBFBFB"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_534_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1474.54 125.55L1532.3 7.30811L1396.98 11.09L1474.54 125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.73 259.663L1518.8 220.738L1474.54 125.55L1374.73 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 107.872L1596.28 -6.51074L1532.3 7.30784L1622.19 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 107.872L1532.3 7.30811L1474.54 125.55L1622.19 107.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.8 220.738L1622.19 107.872L1474.54 125.55L1518.8 220.738Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.81 -158.761L1396.98 11.0898L1532.3 7.30783L1482.81 -158.761Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.81 343.815L1591.12 240.977L1518.8 220.738L1482.81 343.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.8 220.738L1591.12 240.977L1622.19 107.872L1518.8 220.738Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.28 -6.51074L1482.81 -158.761L1532.3 7.30783L1596.28 -6.51074Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.73 259.663L1482.81 343.815L1518.8 220.738L1374.73 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.12 240.977L1742.85 104.908L1622.19 107.872L1591.12 240.977Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 107.872L1744.22 -29.4856L1596.28 -6.51048L1622.19 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.71 283.011L1742.85 104.908L1591.12 240.977L1779.71 283.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.85 104.908L1744.22 -29.4856L1622.19 107.872L1742.85 104.908Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.28 496.066L1627.65 366.243L1482.81 343.815L1596.28 496.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.81 343.815L1627.65 366.243L1591.12 240.977L1482.81 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.65 366.243L1779.71 283.011L1591.12 240.977L1627.65 366.243Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.85 104.908L1899.56 11.0901L1744.22 -29.4856L1742.85 104.908Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.22 473.091L1725.11 380.389L1627.65 366.243L1744.22 473.091Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.65 366.243L1725.11 380.389L1779.71 283.01L1627.65 366.243Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.98 513.667L1532.3 509.885L1482.81 343.815L1396.98 513.667Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877.3 259.663L1880.35 116.434L1779.71 283.011L1877.3 259.663Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.71 283.011L1880.35 116.434L1742.85 104.908L1779.71 283.011Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.3 509.885L1596.28 496.066L1482.81 343.815L1532.3 509.885Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.35 116.434L1899.56 11.0898L1742.85 104.908L1880.35 116.434Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 11.09L1845.39 -160.755L1744.22 -29.4858L1899.56 11.09Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.39 341.822L1877.3 259.663L1779.71 283.011L1845.39 341.822Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.35 116.434L1977.11 125.55L1899.56 11.0898L1880.35 116.434Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.39 341.822L1779.71 283.01L1725.11 380.389L1845.39 341.822Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.22 473.091L1845.39 341.822L1725.11 380.389L1744.22 473.091Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.28 496.066L1744.22 473.091L1627.65 366.243L1596.28 496.066Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 610.448L1744.22 473.091L1596.28 496.066L1622.19 610.448Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021.37 220.738L1977.11 125.55L1877.3 259.663L2021.37 220.738Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877.3 259.663L1977.11 125.55L1880.35 116.434L1877.3 259.663Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 11.09L1985.39 -158.761L1845.39 -160.755L1899.56 11.09Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.3 509.885L1622.19 610.449L1596.28 496.066L1532.3 509.885Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2034.88 7.30783L1985.39 -158.761L1899.56 11.0898L2034.88 7.30783Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1977.11 125.55L2034.88 7.30811L1899.56 11.09L1977.11 125.55Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 343.815L2021.37 220.738L1877.3 259.663L1985.39 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 343.815L1877.3 259.663L1845.39 341.822L1985.39 343.815Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 343.815L1845.39 341.822L1899.56 513.666L1985.39 343.815Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 513.666L1845.39 341.822L1744.22 473.091L1899.56 513.666Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.19 610.448L1742.85 607.485L1744.22 473.091L1622.19 610.448Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.85 607.485L1899.56 513.667L1744.22 473.091L1742.85 607.485Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2034.88 7.30783L2098.86 -6.51074L1985.39 -158.761L2034.88 7.30783Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124.77 107.872L2034.88 7.30811L1977.11 125.55L2124.77 107.872Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124.77 107.872L1977.11 125.55L2021.37 220.738L2124.77 107.872Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130.23 366.243L2093.7 240.977L1985.39 343.815L2130.23 366.243Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.39 343.815L2093.7 240.977L2021.37 220.738L1985.39 343.815Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.56 513.667L2034.88 509.885L1985.39 343.815L1899.56 513.667Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2098.86 496.066L2130.23 366.243L1985.39 343.815L2098.86 496.066Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2034.88 509.885L2098.86 496.066L1985.39 343.815L2034.88 509.885Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(0 1000)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(500 1000)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(0 500)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(500 500)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(1000 1000)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(1500 1000)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(1000 500)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(1500 500)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(500)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(1000)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_534_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(1500)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.c55ab9137b6c0b90bc3df0c69f93fba0.svg";
export { ForwardRef as ReactComponent };